import type { ChangeEvent, FC, HTMLInputTypeAttribute } from 'react';
import { useCallback } from 'react';
import type { ActionProps } from '../../types';
import { observer } from 'mobx-react-lite';
import useRulePageMode from '../../hooks/useRulePageMode';
import useCurrentTasksFormStore from '../../hooks/useCurrentTasksFormStore';
import { TextField } from '@mui/material';

export const ActionValue: FC<ActionProps & { type?: HTMLInputTypeAttribute; disabled?: boolean }> = observer(
  ({ indexAction, indexTask, indexVariant, field, disabled, type = 'text' }) => {
    const { isRead } = useRulePageMode();
    const tasksFormStore = useCurrentTasksFormStore();
    const handleChangeMetric = useCallback(
      (e: ChangeEvent<HTMLInputElement>) => {
        tasksFormStore.setActionFieldValue({
          indexTask,
          indexAction,
          indexVariant,
          field,
          value: e.target.value,
        });
      },
      [tasksFormStore, indexTask, indexVariant, indexAction, field]
    );

    const placeholder = tasksFormStore.getPlaceholder({ indexTask, indexAction, indexVariant, field });

    const storedValue = tasksFormStore.getActionValues({ indexTask, indexAction, indexVariant })?.[field];

    return (
      <TextField
        value={storedValue ?? ''}
        onChange={handleChangeMetric}
        sx={{
          '&.MuiTextField-root': { width: '100%' },
          '& .MuiInputBase-input': { borderRadius: 0 },
          '& .MuiOutlinedInput-root': { maxHeight: 36, minHeight: 36, borderRadius: 0, px: 2 },
          '& fieldset': { border: 'none', top: 0 },
          '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
            display: 'none',
          },
        }}
        InputProps={{ inputProps: { min: 0, style: { padding: 0, textAlign: 'left' } } }}
        type={type}
        placeholder={placeholder}
        disabled={disabled ?? isRead}
      />
    );
  }
);

export default ActionValue;
